module.exports = __webpack_public_path__ + "static/media/users-medical.29b780ba.svg";